"use client";
import { useState } from "react";
import InitialSurvey from "./InitialSurvey";
import { dictionary } from "../utils/dictionary";
import { Language } from "../utils/dictionary";
import { useAuth } from "../context/AuthContext";

export default function StartSurvey() {
    const [started, setStarted] = useState(false);
    const { language } = useAuth();

    if (started) {
        return <InitialSurvey />;
    }

    return (
        <div className="absolute top-0 left-0 w-full h-full z-[9999] min-h-screen bg-[#F5F6FA] flex flex-col items-center justify-center font-plus-jakarta-sans text-center px-6">
            <div className="max-w-2xl">
                <h1 className="text-[#0E172A] font-extrabold text-[58px] leading-[1.1] mb-8 text-start">
                    {dictionary["survey-title"][language as Language]}
                </h1>
                <button
                    onClick={() => setStarted(true)}
                    className="mt-4 bg-[#0E172A] hover:bg-[#0E172A]/80 text-white text-2xl font-semibold py-4 px-8 rounded-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2"
                >
                    {dictionary["start-survey"][language as Language]}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="w-6 h-6"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 5l7 7-7 7"
                        />
                    </svg>
                </button>
            </div>
        </div>
    );
}
